import React, {useState} from "react";
import * as ReactBootstrap from "react-bootstrap";
import {Tree} from "./Tree";

export const Template = ({templateId, trees, onUpdate}) => {
    const [output, _setOutPut] = useState([])
    let tmp = null
    const onTreeUpdate = (treeId, data) => {
        for (let i = 0; i < output.length; i++) {
            if (output[i].treeId === treeId) {
                tmp = [
                    ...output.slice(0, i),
                    {treeId: treeId, questions: data},
                    ...output.slice(i + 1),
                ]
                _setOutPut(tmp)
                onUpdate(templateId, tmp)
                return
            }
        }
        tmp = [...output, {treeId: treeId, questions: data}]
        _setOutPut(tmp)
        onUpdate(templateId, tmp)
    }
    return (
        <>
            {trees.map((tree) => {
                return (
                    <ReactBootstrap.Form key={`${tree.treeId}-form`}>
                        <Tree
                            key={tree.treeId}
                            treeId={tree.treeId}
                            questions={tree.questions}
                            onTreeUpdate={onTreeUpdate}
                        />
                    </ReactBootstrap.Form>
                )
            })}
        </>
    )
}
